// Where the signed-in session lives in the browser, shared by api/axiosConfig and hooks/useAuth.

/** Fired on window when the API rejects the stored token; AuthProvider signs out on it. */
export const SESSION_EXPIRED_EVENT = "sap:session-expired";

/** The stored "Bearer …" token, or null. localStorage keeps it JSON-encoded under `jwt`. */
export const readStoredToken = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = window.localStorage.getItem("jwt");
    const parsed = raw ? JSON.parse(raw) : null;
    return typeof parsed === "string" && parsed ? parsed : null;
  } catch (err) {
    return null;
  }
};

export const clearStoredSession = () => {
  try {
    window.localStorage.removeItem("jwt");
    window.localStorage.removeItem("user");
  } catch (err) {
    console.warn("Unable to clear stored session", err);
  }
};
